<template>

    <form v-on:submit.prevent="onSubmit()">

      <div class="hit-form-group">
        <div class="hit-input-group">
          <span class="hit-input-group-addon"><loginStatus :error="error.username" /></span>
          <input type="text" spellcheck="false" class="hit-form-control" v-model="username" v-bind:placeholder="$t('message.username')"/>
        </div>
      </div>

      <div class="hit-form-group">
        <div class="hit-input-group">
          <span class="hit-input-group-addon"><loginStatus :error="error.password" /></span>
          <input type="password" spellcheck="false" class="hit-form-control" v-model="password" v-bind:placeholder="$t('message.password')"/>
        </div>
      </div>

      <div class="hit-form-group" v-if="getAlert()">
        <div class="hit-alert hit-alert-danger">{{ $t("message.falseLogin") }}</div>
      </div>

      <div class="hit-form-group">
        <button class="hit-btn hit-btn-primary hit-btn-block">{{ $t("message.signIn") }}</button>
      </div>

    </form>

</template>

<script>
import loginStatus from '@core/components/content/login_status'

export default{

  components: {loginStatus},
  props: {settings: Object},

  data () {
    return {
      username: '',
      password: '',

      error: {
        username: true,
        password: true
      }

    }
  },

  watch: {

    username: function (value) { if (value.length < 4) { this.error.username = true } else { this.error.username = false } this.username = this.usernameBeauty(value) },
    password: function (value) { if (value.length < 1) { this.error.password = true } else { this.error.password = false } }

  },

  methods: {

    getAlert () {
      if (typeof this.settings.getError !== 'function') { return false }

      return this.settings.getError()
    },

    usernameBeauty (value) {
      var username = value
      username = username.toLowerCase()

      username = username.replace(/ö/g, 'oe')
      username = username.replace(/ä/g, 'ae')
      username = username.replace(/ü/g, 'ue')
      username = username.replace(/ß/g, 'ss')
      // username = username.replace(/[^a-z ]/g, '')
      username = username.replace(' ', '')

      return username
    },

    onSubmit () {
      var error = false

      Object.values(this.error).forEach(function (v) {
        if (v == true) {
          error = true
          return false
        }
      })

      if (!error) { this.settings.onSubmit({username: this.username, password: this.password}) }
    }
  }

}
</script>
